<div class="apto-form-control">
    <ng-content select="form-label"></ng-content>
    <ng-content select="form-value"></ng-content>
</div>